import styled from 'styled-components';

export const MainDetailsContainer = styled.div`
  width: 100%;
  max-width: 1300px;
  padding: 20px;
  overflow: hidden;
`;
